export function normalizeForSearch(text) {
    return text
        .toLowerCase()
        .normalize('NFC')
        .replace(/á/g, 'a')
        .replace(/é/g, 'e')
        .replace(/í/g, 'i')
        .replace(/[óöő]/g, 'o')
        .replace(/[úüű]/g, 'u')
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
}

export function slugify(text) {
    if (!text) {
        return ''
    }
    return text
        .toLowerCase()
        .replace(/á/g, 'a')
        .replace(/é/g, 'e')
        .replace(/í/g, 'i')
        .replace(/[óöő]/g, 'o')
        .replace(/[úüű]/g, 'u')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
}

export function findCityBySlug(slug, cityIndex) {
    const normalizedSlug = slugify(slug)
    const indexes = cityIndex.bySlug[normalizedSlug]
    if (!indexes) return []
    return indexes.map((i) => cityIndex.items[i])
}
